// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-height: 60px;
  --progress-bar-height: 5px;
  --page-padding: 50px;
  --element-spacing: 20px;
  --menu-width: 250px;
}

body {
  margin: 0;
  -ms-overflow-style: none; /* Hide y-scrollbar: IE and Edge */
  scrollbar-width: none; /* Hide y-scrollbar: Firefox */
  background-color: var(--motes-light-black);
  color: var(--motes-white);
}
body::-webkit-scrollbar { /* Hide y-scrollbar: Chrome */
  display: none;
}
body.modal-open {
  width: 100%;
  overflow: hidden;
  position: fixed;
  touch-action: none;
  -webkit-overflow-scrolling: none;
  overscroll-behavior: none;
}

div.line-spacer {
  margin: 10px auto;
  border-color: rgba(155, 155, 155, 0.5);
}

a {
  color: var(--motes-blue-link);
  font-weight: bold;
}

#map {
  position: fixed;
  top: var(--header-height);
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
}
#map .moteMapMarkerTextContainer {
  display: none;
}
#map.hide {
  opacity: 0;
  z-index: -1;
}

section.map-bg {
  position: relative;
  transition: 1s;
}

.video-player #video-player, .video-player #image-player {
  z-index: 21;
}
.video-player #video-player, .video-player #close-fullscreen {
  top: var(--header-height);
}

.mobile-overlay h3::after {
  content: "";
  display: block;
  width: 100px;
  padding-top: var(--motes-padding);
  border-bottom: 3px solid var(--primary-color);
  margin: 0 auto;
}

.menu-container .premium {
  display: flex;
  align-items: center;
  background-color: var(--motes-white);
  color: var(--motes-black);
  border-radius: var(--border-radius);
  padding: 0 7px;
  font-size: 12px;
  margin-left: auto;
  margin-right: var(--motes-padding);
  font-weight: bold;
  height: 20px;
}
.menu-container .premium svg-icon {
  margin-right: 4px;
}

/** Deviations from light-golden-theme only used in Creator **/
@media only screen and (min-width: 600px) {
  .light-golden-theme p, .light-golden-theme ol, .light-golden-theme ul, .light-golden-theme h4 {
    font-size: 16px;
    line-height: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACA;EACI,qBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,SAAA;EACA,wBAAA,EAAA,kCAAA;EACA,qBAAA,EAAA,8BAAA;EACA,0CAAA;EACA,yBAAA;AAAJ;AAEI,0BAAA,6BAAA;EACI,aAAA;AAAR;AAGI;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;AADR;;AAKA;EACI,iBAAA;EACA,sCAAA;AAFJ;;AAKA;EACI,6BAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,yBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AAFJ;AAII;EACI,aAAA;AAFR;AAKI;EACI,UAAA;EACA,WAAA;AAHR;;AAQA;EACI,kBAAA;EACA,cAAA;AALJ;;AAUI;EACI,WAAA;AAPR;AAUI;EACI,yBAAA;AARR;;AAcI;EACI,WAAA;EACA,cAAA;EACA,YAAA;EACA,iCAAA;EACA,6CAAA;EACA,cAAA;AAXR;;AAeA;EACI,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,iBAAA;EACA,YAAA;AAZJ;AAcI;EACI,iBAAA;AAZR;;AAgBA,8DAAA;AAEI;EACI;IACI,eAAA;IACA,iBAAA;EAdV;AACF","sourcesContent":["\n:root {\n    --header-height: 60px;\n    --progress-bar-height: 5px;\n    --page-padding: 50px;\n    --element-spacing: 20px;\n    --menu-width: 250px;\n}\n\nbody {\n    margin: 0;\n    -ms-overflow-style: none;  /* Hide y-scrollbar: IE and Edge */\n    scrollbar-width: none;  /* Hide y-scrollbar: Firefox */\n    background-color: var(--motes-light-black);\n    color: var(--motes-white);\n\n    &::-webkit-scrollbar { /* Hide y-scrollbar: Chrome */\n        display: none;\n    }\n\n    &.modal-open {\n        width: 100%;\n        overflow: hidden;\n        position: fixed;\n        touch-action: none;\n        -webkit-overflow-scrolling: none;\n        overscroll-behavior: none;\n    }\n}\n\ndiv.line-spacer {\n    margin: 10px auto;\n    border-color: rgba(155,155,155,.5);\n}\n\na {\n    color: var(--motes-blue-link);\n    font-weight: bold;\n}\n\n#map {\n    position: fixed;\n    top: var(--header-height);\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 0;\n\n    .moteMapMarkerTextContainer {\n        display: none;\n    }\n\n    &.hide {\n        opacity: 0;\n        z-index: -1;\n    }\n}\n\n\nsection.map-bg {\n    position: relative;\n    transition: 1s;\n}\n\n.video-player {\n\n    #video-player, #image-player {\n        z-index: 21;\n    }\n\n    #video-player, #close-fullscreen {\n        top: var(--header-height);\n    }\n\n}\n\n.mobile-overlay {\n    h3::after {\n        content: \"\";\n        display: block;\n        width: 100px;\n        padding-top: var(--motes-padding);\n        border-bottom: 3px solid var(--primary-color);\n        margin: 0 auto;\n    }\n}\n\n.menu-container .premium {\n    display: flex;\n    align-items: center;\n    background-color: var(--motes-white);\n    color: var(--motes-black);\n    border-radius: var(--border-radius);\n    padding: 0 7px;\n    font-size: 12px;\n    margin-left: auto;\n    margin-right: var(--motes-padding);\n    font-weight: bold;\n    height: 20px;\n\n    svg-icon {\n        margin-right: 4px;\n    }\n}\n\n/** Deviations from light-golden-theme only used in Creator **/\n.light-golden-theme {\n    @media only screen and (min-width: 600px) {\n        p, ol, ul, h4 {\n            font-size: 16px;\n            line-height: 22px;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
